export default __webpack_public_path__ + "static/media/_DSC0412.9c910ea1.JPG";